module.exports = __webpack_public_path__ + "img/7.60773ba7.jpg";